import { render, staticRenderFns } from "./CarInfractions.vue?vue&type=template&id=420e8c7c&scoped=true&"
import script from "./CarInfractions.vue?vue&type=script&lang=ts&"
export * from "./CarInfractions.vue?vue&type=script&lang=ts&"
import style0 from "./car-infractions.scss?vue&type=style&index=0&id=420e8c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420e8c7c",
  null
  
)

export default component.exports